"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JointAppValidationUtils = void 0;
var TermLifeValidationUtils_1 = require("./TermLifeValidationUtils");
var WholeLifeValidationUtils_1 = require("./WholeLifeValidationUtils");
var JointAppValidationUtils = /** @class */ (function () {
    function JointAppValidationUtils() {
    }
    JointAppValidationUtils.isValidFaceAmount = function (wholeLifeProductCode, wholeLifeFaceAmount, termProductCode, termFaceAmount, rtrAmount, dob, healthClass, lowFaceWholeLifeEnabled, isUsCitizen, lowFaceWL10Enabled) {
        if (lowFaceWholeLifeEnabled === void 0) { lowFaceWholeLifeEnabled = true; }
        if (isUsCitizen === void 0) { isUsCitizen = true; }
        if (lowFaceWL10Enabled === void 0) { lowFaceWL10Enabled = true; }
        var validationResult = WholeLifeValidationUtils_1.WholeLifeValidationUtils.isValidFaceAmount(wholeLifeProductCode, wholeLifeFaceAmount, rtrAmount, dob, healthClass, lowFaceWholeLifeEnabled, isUsCitizen, lowFaceWL10Enabled);
        if (!validationResult.isValid) {
            return validationResult;
        }
        validationResult = TermLifeValidationUtils_1.TermLifeValidationUtils.isValidFaceAmount(termProductCode, termFaceAmount, dob, isUsCitizen);
        if (!validationResult.isValid) {
            return validationResult;
        }
        var totalFaceAmount = termFaceAmount + wholeLifeFaceAmount;
        validationResult = TermLifeValidationUtils_1.TermLifeValidationUtils.isValidFaceAmount(termProductCode, totalFaceAmount, dob, isUsCitizen);
        if (!validationResult.isValid) {
            return validationResult;
        }
        return WholeLifeValidationUtils_1.WholeLifeValidationUtils.isValidFaceAmount(wholeLifeProductCode, totalFaceAmount, rtrAmount, dob, healthClass, lowFaceWholeLifeEnabled, isUsCitizen, lowFaceWL10Enabled);
    };
    return JointAppValidationUtils;
}());
exports.JointAppValidationUtils = JointAppValidationUtils;
